import _slicedToArray from "C:\\Users\\nanma\\Documents\\GitHub\\star\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "C:\\Users\\nanma\\Documents\\GitHub\\star\\node_modules\\@babel\\runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["## Raw vZome Exports"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["## Dependencies"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\nThere is more to do before we have an alternative to [convertVsonModel](#convertVsonModel) function\nthat uses this mapping... future work.\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n## A Different Approach\n\nThe code above resolves the imported VSON models by ignoring the strut\nmetadata, and just looking at the endpoints of each strut, resolving\nthe vector between them using Jacob's code.\n\nA more efficient method is to *map* the VSON strut metadata directly\ninto the orbits, orientations, and reflections as understood by Observable vZome.\nThis code captures that mapping.\n\nWe start with orientation, which is an integer between zero and fifty-nine, inclusive.\nIn traditional vZome, this indexes a list of transformation matrices.\nIn Observable vZome, it indexes a list of quaternions.\nBoth lists contains exactly the same orientations, but in different orders.\nHere, we are providing functions to map either index to the triple\nof integers used in [Jacob's notebook](https://beta.observablehq.com/@jrus/zome-arithmetic#icosahedral_quaternions).\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["# WIP Importing vZome Models\n\n[Observable vZome](https://beta.observablehq.com/@vorth/wip-observable-vzome)\nis designed to be somewhat independent of [desktop vZome](http://vzome.com).\nIn particular, it has its own definition of icosahedral symmetry in terms\nof a set of quaternions, and it has a more rational approach to associating\nshapes with vectors, based on canonicalization.\n\nFinally, Observable vZome uses a simpler, three-integer representation of\na number in the Golden field (two factors, one common divisor),\nwhereas vZome uses a four-integer representation (two factors, each with its\nown divisor).\n\nThis notebook contains a function to normalize vZome \"VSON\" exports\nas ready-to-render (\"resolved\") models for Observable vZome.\n\nIn the future, we will provide full interchange between models created\nin desktop vZome, and models generated using Javascript code.\n\n## Models\n\nThese models, as exported from vZome, use its \"VSON\" representation, with all numbers represented\nexactly as rational tuples, and all struts already resolved into orbit, length, and orientations.\n\nHere, they have been converted for use with Observable vZome."]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// https://observablehq.com/@vorth/wip-importing-vzome-models@2968
import define1 from "../@vorth/wip-observable-vzome.js";
import define2 from "../@vorth/wip-importing-vzome-shapes.js";
export default function define(runtime, observer) {
  var main = runtime.module();
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject());
  });
  main.variable(observer()).define(["vZomeRenderer", "red_quat_120_cell"], function (vZomeRenderer, red_quat_120_cell) {
    return vZomeRenderer(red_quat_120_cell);
  });
  main.variable(observer("test_VSON_model")).define("test_VSON_model", ["convertVsonModel"], function (convertVsonModel) {
    return convertVsonModel({
      "field": "golden",
      "symmetry": "icosahedral",
      "vertices": [[[0, 0], [0, 0], [0, 0]], [[1, 2], [0, 0], [2, 3]], [[1, 2], [3, 5], [0, 0]], [[2, 4], [0, 0], [0, 0]], [[2, 4], [0, 0], [4, 6]]],
      "balls": [2, 1, 4, 0, 3],
      "struts": [{
        "start": 0,
        "end": 2,
        "length": [1, 2],
        "orbit": "yellow",
        "orientation": 6
      }, {
        "start": 1,
        "end": 4,
        "length": [1, 2],
        "orbit": "red",
        "orientation": 2
      }, {
        "start": 0,
        "end": 1,
        "length": [1, 2],
        "orbit": "red",
        "orientation": 2
      }, {
        "start": 3,
        "end": 4,
        "length": [4, 6],
        "orbit": "blue",
        "orientation": 2
      }, {
        "start": 2,
        "end": 1,
        "length": [2, 3],
        "orbit": "red",
        "orientation": 31
      }, {
        "start": 2,
        "end": 3,
        "length": [1, 2],
        "orbit": "yellow",
        "orientation": 21
      }, {
        "start": 0,
        "end": 3,
        "length": [2, 4],
        "orbit": "blue",
        "orientation": 0
      }]
    });
  });
  main.variable(observer("purple_triangles")).define("purple_triangles", ["convertVsonModel"], function (convertVsonModel) {
    return convertVsonModel({
      "field": "golden",
      "symmetry": "icosahedral",
      "vertices": [[[-2, -4], [0, 0], [0, 0]], [[-2, -3], [-1, -1], [-1, -2]], [[-2, -3], [-1, -1], [1, 2]], [[-2, -3], [1, 1], [-1, -2]], [[-2, -3], [1, 1], [1, 2]], [[-1, -2], [-2, -3], [-1, -1]], [[-1, -2], [-2, -3], [1, 1]], [[-1, -2], [2, 3], [-1, -1]], [[-1, -2], [2, 3], [1, 1]], [[-1, -1], [-1, -2], [-2, -3]], [[-1, -1], [-1, -2], [2, 3]], [[-1, -1], [1, 2], [-2, -3]], [[-1, -1], [1, 2], [2, 3]], [[0, 0], [-2, -4], [0, 0]], [[0, 0], [0, 0], [-2, -4]], [[0, 0], [0, 0], [2, 4]], [[0, 0], [2, 4], [0, 0]], [[1, 1], [-1, -2], [-2, -3]], [[1, 1], [-1, -2], [2, 3]], [[1, 1], [1, 2], [-2, -3]], [[1, 1], [1, 2], [2, 3]], [[1, 2], [-2, -3], [-1, -1]], [[1, 2], [-2, -3], [1, 1]], [[1, 2], [2, 3], [-1, -1]], [[1, 2], [2, 3], [1, 1]], [[2, 3], [-1, -1], [-1, -2]], [[2, 3], [-1, -1], [1, 2]], [[2, 3], [1, 1], [-1, -2]], [[2, 3], [1, 1], [1, 2]], [[2, 4], [0, 0], [0, 0]]],
      "balls": [13, 2, 12, 5, 3, 24, 8, 18, 10, 19, 25, 11, 1, 16, 29, 9, 0, 26, 20, 21, 14, 27, 22, 15, 6, 23, 28, 7, 17, 4],
      "struts": [{
        "start": 28,
        "end": 11,
        "length": [2, 2],
        "orbit": "purple",
        "orientation": 56
      }, {
        "start": 23,
        "end": 22,
        "length": [2, 2],
        "orbit": "purple",
        "orientation": 31
      }, {
        "start": 16,
        "end": 9,
        "length": [2, 2],
        "orbit": "purple",
        "orientation": 19
      }, {
        "start": 15,
        "end": 27,
        "length": [2, 2],
        "orbit": "purple",
        "orientation": 20
      }, {
        "start": 16,
        "end": 18,
        "length": [2, 2],
        "orbit": "purple",
        "orientation": 34
      }, {
        "start": 15,
        "end": 1,
        "length": [2, 2],
        "orbit": "purple",
        "orientation": 50
      }, {
        "start": 17,
        "end": 2,
        "length": [2, 2],
        "orbit": "purple",
        "orientation": 38
      }, {
        "start": 20,
        "end": 3,
        "length": [2, 2],
        "orbit": "purple",
        "orientation": 53
      }, {
        "start": 14,
        "end": 26,
        "length": [2, 2],
        "orbit": "purple",
        "orientation": 5
      }, {
        "start": 12,
        "end": 19,
        "length": [2, 2],
        "orbit": "purple",
        "orientation": 17
      }, {
        "start": 27,
        "end": 1,
        "length": [2, 2],
        "orbit": "purple",
        "orientation": 30
      }, {
        "start": 21,
        "end": 3,
        "length": [2, 2],
        "orbit": "purple",
        "orientation": 54
      }, {
        "start": 24,
        "end": 2,
        "length": [2, 2],
        "orbit": "purple",
        "orientation": 39
      }, {
        "start": 24,
        "end": 17,
        "length": [2, 2],
        "orbit": "purple",
        "orientation": 22
      }, {
        "start": 10,
        "end": 7,
        "length": [2, 2],
        "orbit": "purple",
        "orientation": 55
      }, {
        "start": 5,
        "end": 8,
        "length": [2, 2],
        "orbit": "purple",
        "orientation": 1
      }, {
        "start": 25,
        "end": 10,
        "length": [2, 2],
        "orbit": "purple",
        "orientation": 41
      }, {
        "start": 29,
        "end": 8,
        "length": [2, 2],
        "orbit": "purple",
        "orientation": 48
      }, {
        "start": 13,
        "end": 12,
        "length": [2, 2],
        "orbit": "purple",
        "orientation": 4
      }, {
        "start": 0,
        "end": 23,
        "length": [2, 2],
        "orbit": "purple",
        "orientation": 3
      }, {
        "start": 13,
        "end": 19,
        "length": [2, 2],
        "orbit": "purple",
        "orientation": 49
      }, {
        "start": 26,
        "end": 4,
        "length": [2, 2],
        "orbit": "purple",
        "orientation": 45
      }, {
        "start": 29,
        "end": 5,
        "length": [2, 2],
        "orbit": "purple",
        "orientation": 33
      }, {
        "start": 0,
        "end": 22,
        "length": [2, 2],
        "orbit": "purple",
        "orientation": 18
      }, {
        "start": 25,
        "end": 7,
        "length": [2, 2],
        "orbit": "purple",
        "orientation": 51
      }, {
        "start": 20,
        "end": 21,
        "length": [2, 2],
        "orbit": "purple",
        "orientation": 25
      }, {
        "start": 28,
        "end": 6,
        "length": [2, 2],
        "orbit": "purple",
        "orientation": 36
      }, {
        "start": 6,
        "end": 11,
        "length": [2, 2],
        "orbit": "purple",
        "orientation": 52
      }, {
        "start": 14,
        "end": 4,
        "length": [2, 2],
        "orbit": "purple",
        "orientation": 35
      }, {
        "start": 9,
        "end": 18,
        "length": [2, 2],
        "orbit": "purple",
        "orientation": 2
      }]
    });
  });
  main.variable(observer("sixty_spruce")).define("sixty_spruce", ["convertVsonModel"], function (convertVsonModel) {
    return convertVsonModel({
      "field": "golden",
      "symmetry": "icosahedral",
      "vertices": [[[-7, -10], [0, -3], [-1, -1]], [[-7, -10], [0, 3], [1, 1]], [[-7, -9], [-1, -4], [2, 3]], [[-7, -9], [1, 4], [-2, -3]], [[-6, -8], [-2, -6], [-2, -4]], [[-6, -8], [2, 6], [2, 4]], [[-4, -9], [-1, -1], [-5, -6]], [[-4, -9], [1, 1], [5, 6]], [[-5, -7], [-3, -8], [2, 3]], [[-5, -7], [3, 8], [-2, -3]], [[-3, -8], [-2, -3], [5, 7]], [[-3, -8], [2, 3], [-5, -7]], [[-5, -6], [-4, -9], [-1, -1]], [[-5, -6], [4, 9], [1, 1]], [[-4, -5], [0, -1], [0, 1]], [[-4, -5], [0, 1], [0, -1]], [[-2, -6], [-2, -4], [-6, -8]], [[-2, -6], [2, 4], [6, 8]], [[-3, -5], [0, -2], [-1, -2]], [[-3, -5], [0, 2], [1, 2]], [[-2, -5], [0, -1], [2, 3]], [[-2, -5], [0, 1], [-2, -3]], [[-3, -4], [-1, -3], [2, 2]], [[-3, -4], [1, 3], [-2, -2]], [[-2, -4], [-6, -8], [-2, -6]], [[-2, -4], [-1, -2], [-3, -3]], [[-2, -4], [1, 2], [3, 3]], [[-2, -4], [6, 8], [2, 6]], [[-3, -3], [-2, -4], [-1, -2]], [[-3, -3], [2, 4], [1, 2]], [[-1, -4], [-2, -3], [7, 9]], [[-1, -4], [2, 3], [-7, -9]], [[-2, -3], [-7, -9], [1, 4]], [[-2, -3], [-5, -7], [3, 8]], [[-2, -3], [-2, -5], [0, 1]], [[-2, -3], [2, 5], [0, -1]], [[-2, -3], [5, 7], [-3, -8]], [[-2, -3], [7, 9], [-1, -4]], [[-1, -3], [-2, -2], [3, 4]], [[-1, -3], [2, 2], [-3, -4]], [[-2, -2], [-3, -4], [1, 3]], [[-2, -2], [3, 4], [-1, -3]], [[0, -3], [-1, -1], [-7, -10]], [[0, -3], [1, 1], [7, 10]], [[-1, -2], [-3, -5], [0, -2]], [[-1, -2], [-3, -3], [-2, -4]], [[-1, -2], [3, 3], [2, 4]], [[-1, -2], [3, 5], [0, 2]], [[0, -2], [-1, -2], [-3, -5]], [[0, -2], [1, 2], [3, 5]], [[-1, -1], [-7, -10], [0, -3]], [[-1, -1], [-5, -6], [-4, -9]], [[-1, -1], [5, 6], [4, 9]], [[-1, -1], [7, 10], [0, 3]], [[0, -1], [-4, -5], [0, 1]], [[0, -1], [-2, -3], [2, 5]], [[0, -1], [0, -1], [4, 5]], [[0, -1], [0, 1], [-4, -5]], [[0, -1], [2, 3], [-2, -5]], [[0, -1], [4, 5], [0, -1]], [[0, 1], [-4, -5], [0, -1]], [[0, 1], [-2, -3], [-2, -5]], [[0, 1], [0, -1], [-4, -5]], [[0, 1], [0, 1], [4, 5]], [[0, 1], [2, 3], [2, 5]], [[0, 1], [4, 5], [0, 1]], [[1, 1], [-7, -10], [0, 3]], [[1, 1], [-5, -6], [4, 9]], [[1, 1], [5, 6], [-4, -9]], [[1, 1], [7, 10], [0, -3]], [[0, 2], [-1, -2], [3, 5]], [[0, 2], [1, 2], [-3, -5]], [[1, 2], [-3, -5], [0, 2]], [[1, 2], [-3, -3], [2, 4]], [[1, 2], [3, 3], [-2, -4]], [[1, 2], [3, 5], [0, -2]], [[0, 3], [-1, -1], [7, 10]], [[0, 3], [1, 1], [-7, -10]], [[2, 2], [-3, -4], [-1, -3]], [[2, 2], [3, 4], [1, 3]], [[1, 3], [-2, -2], [-3, -4]], [[1, 3], [2, 2], [3, 4]], [[2, 3], [-7, -9], [-1, -4]], [[2, 3], [-5, -7], [-3, -8]], [[2, 3], [-2, -5], [0, -1]], [[2, 3], [2, 5], [0, 1]], [[2, 3], [5, 7], [3, 8]], [[2, 3], [7, 9], [1, 4]], [[1, 4], [-2, -3], [-7, -9]], [[1, 4], [2, 3], [7, 9]], [[3, 3], [-2, -4], [1, 2]], [[3, 3], [2, 4], [-1, -2]], [[2, 4], [-6, -8], [2, 6]], [[2, 4], [-1, -2], [3, 3]], [[2, 4], [1, 2], [-3, -3]], [[2, 4], [6, 8], [-2, -6]], [[3, 4], [-1, -3], [-2, -2]], [[3, 4], [1, 3], [2, 2]], [[2, 5], [0, -1], [-2, -3]], [[2, 5], [0, 1], [2, 3]], [[3, 5], [0, -2], [1, 2]], [[3, 5], [0, 2], [-1, -2]], [[2, 6], [-2, -4], [6, 8]], [[2, 6], [2, 4], [-6, -8]], [[4, 5], [0, -1], [0, -1]], [[4, 5], [0, 1], [0, 1]], [[5, 6], [-4, -9], [1, 1]], [[5, 6], [4, 9], [-1, -1]], [[3, 8], [-2, -3], [-5, -7]], [[3, 8], [2, 3], [5, 7]], [[5, 7], [-3, -8], [-2, -3]], [[5, 7], [3, 8], [2, 3]], [[4, 9], [-1, -1], [5, 6]], [[4, 9], [1, 1], [-5, -6]], [[6, 8], [-2, -6], [2, 4]], [[6, 8], [2, 6], [-2, -4]], [[7, 9], [-1, -4], [-2, -3]], [[7, 9], [1, 4], [2, 3]], [[7, 10], [0, -3], [1, 1]], [[7, 10], [0, 3], [-1, -1]]],
      "balls": [57, 33, 96, 98, 67, 29, 71, 116, 39, 47, 111, 94, 14, 4, 119, 44, 105, 34, 19, 63, 102, 110, 21, 115, 50, 59, 86, 60, 85, 117, 109, 92, 55, 75, 70, 38, 87, 10, 101, 89, 41, 53, 112, 45, 37, 18, 77, 36, 68, 82, 2, 28, 43, 30, 27, 106, 74, 72, 83, 8, 69, 7, 78, 84, 1, 11, 24, 40, 113, 66, 32, 80, 13, 103, 42, 114, 6, 79, 35, 58, 104, 56, 93, 90, 15, 51, 88, 22, 54, 12, 95, 91, 23, 81, 46, 26, 100, 17, 61, 49, 31, 62, 108, 73, 3, 107, 97, 76, 52, 48, 65, 16, 20, 118, 99, 64, 25, 0, 5, 9],
      "struts": [{
        "start": 74,
        "end": 95,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 57
      }, {
        "start": 59,
        "end": 37,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 23
      }, {
        "start": 96,
        "end": 110,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 11
      }, {
        "start": 94,
        "end": 103,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 28
      }, {
        "start": 85,
        "end": 107,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 18
      }, {
        "start": 78,
        "end": 83,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 39
      }, {
        "start": 71,
        "end": 77,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 15
      }, {
        "start": 34,
        "end": 12,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 48
      }, {
        "start": 49,
        "end": 43,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 30
      }, {
        "start": 73,
        "end": 92,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 42
      }, {
        "start": 55,
        "end": 67,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 19
      }, {
        "start": 25,
        "end": 16,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 58
      }, {
        "start": 15,
        "end": 3,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 7
      }, {
        "start": 26,
        "end": 17,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 43
      }, {
        "start": 44,
        "end": 50,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 17
      }, {
        "start": 48,
        "end": 42,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 45
      }, {
        "start": 39,
        "end": 11,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 25
      }, {
        "start": 20,
        "end": 7,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 5
      }, {
        "start": 54,
        "end": 32,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 8
      }, {
        "start": 22,
        "end": 8,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 56
      }, {
        "start": 93,
        "end": 102,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 13
      }, {
        "start": 46,
        "end": 27,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 12
      }, {
        "start": 65,
        "end": 87,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 38
      }, {
        "start": 104,
        "end": 116,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 37
      }, {
        "start": 80,
        "end": 108,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 55
      }, {
        "start": 58,
        "end": 68,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 4
      }, {
        "start": 62,
        "end": 88,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 6
      }, {
        "start": 28,
        "end": 4,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 44
      }, {
        "start": 64,
        "end": 52,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 49
      }, {
        "start": 100,
        "end": 118,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 16
      }, {
        "start": 38,
        "end": 10,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 10
      }, {
        "start": 40,
        "end": 33,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 24
      }, {
        "start": 56,
        "end": 30,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 51
      }, {
        "start": 45,
        "end": 24,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 27
      }, {
        "start": 105,
        "end": 117,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 52
      }, {
        "start": 14,
        "end": 2,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 22
      }, {
        "start": 99,
        "end": 112,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 35
      }, {
        "start": 81,
        "end": 109,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 40
      }, {
        "start": 23,
        "end": 9,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 41
      }, {
        "start": 21,
        "end": 6,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 20
      }, {
        "start": 61,
        "end": 51,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 34
      }, {
        "start": 19,
        "end": 1,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 46
      }, {
        "start": 101,
        "end": 119,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 1
      }, {
        "start": 63,
        "end": 89,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 21
      }, {
        "start": 35,
        "end": 13,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 33
      }, {
        "start": 91,
        "end": 115,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 14
      }, {
        "start": 98,
        "end": 113,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 50
      }, {
        "start": 57,
        "end": 31,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 36
      }, {
        "start": 84,
        "end": 106,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 3
      }, {
        "start": 75,
        "end": 69,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 47
      }, {
        "start": 70,
        "end": 76,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 0
      }, {
        "start": 41,
        "end": 36,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 9
      }, {
        "start": 18,
        "end": 0,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 31
      }, {
        "start": 47,
        "end": 53,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 2
      }, {
        "start": 29,
        "end": 5,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 59
      }, {
        "start": 79,
        "end": 86,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 54
      }, {
        "start": 97,
        "end": 111,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 26
      }, {
        "start": 60,
        "end": 82,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 53
      }, {
        "start": 90,
        "end": 114,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 29
      }, {
        "start": 72,
        "end": 66,
        "length": [2, 3],
        "orbit": "spruce",
        "orientation": 32
      }]
    });
  });
  main.variable(observer("all_turquoise")).define("all_turquoise", ["convertVsonModel"], function (convertVsonModel) {
    return convertVsonModel({
      "field": "golden",
      "symmetry": "icosahedral",
      "vertices": [[[-8, -12], [-2, -2], [0, -2]], [[-8, -12], [-2, -2], [0, 2]], [[-8, -12], [2, 2], [0, -2]], [[-8, -12], [2, 2], [0, 2]], [[-6, -12], [-2, -4], [-2, -4]], [[-6, -12], [-2, -4], [2, 4]], [[-6, -12], [2, 4], [-2, -4]], [[-6, -12], [2, 4], [2, 4]], [[-6, -10], [-4, -6], [-4, -4]], [[-6, -10], [-4, -6], [4, 4]], [[-6, -10], [0, -2], [-4, -8]], [[-6, -10], [0, -2], [4, 8]], [[-6, -10], [0, 2], [-4, -8]], [[-6, -10], [0, 2], [4, 8]], [[-6, -10], [4, 6], [-4, -4]], [[-6, -10], [4, 6], [4, 4]], [[-6, -8], [-6, -8], [-2, -4]], [[-6, -8], [-6, -8], [2, 4]], [[-6, -8], [-2, -4], [-6, -8]], [[-6, -8], [-2, -4], [6, 8]], [[-6, -8], [2, 4], [-6, -8]], [[-6, -8], [2, 4], [6, 8]], [[-6, -8], [6, 8], [-2, -4]], [[-6, -8], [6, 8], [2, 4]], [[-4, -8], [-6, -10], [0, -2]], [[-4, -8], [-6, -10], [0, 2]], [[-4, -8], [6, 10], [0, -2]], [[-4, -8], [6, 10], [0, 2]], [[-4, -6], [-4, -4], [-6, -10]], [[-4, -6], [-4, -4], [6, 10]], [[-4, -6], [-1, -1], [0, -1]], [[-4, -6], [-1, -1], [0, 1]], [[-4, -6], [1, 1], [0, -1]], [[-4, -6], [1, 1], [0, 1]], [[-4, -6], [4, 4], [-6, -10]], [[-4, -6], [4, 4], [6, 10]], [[-3, -6], [-1, -2], [-1, -2]], [[-3, -6], [-1, -2], [1, 2]], [[-3, -6], [1, 2], [-1, -2]], [[-3, -6], [1, 2], [1, 2]], [[-3, -5], [-2, -3], [-2, -2]], [[-3, -5], [-2, -3], [2, 2]], [[-3, -5], [0, -1], [-2, -4]], [[-3, -5], [0, -1], [2, 4]], [[-3, -5], [0, 1], [-2, -4]], [[-3, -5], [0, 1], [2, 4]], [[-3, -5], [2, 3], [-2, -2]], [[-3, -5], [2, 3], [2, 2]], [[-4, -4], [-6, -10], [-4, -6]], [[-4, -4], [-6, -10], [4, 6]], [[-4, -4], [6, 10], [-4, -6]], [[-4, -4], [6, 10], [4, 6]], [[-3, -4], [-3, -4], [-1, -2]], [[-3, -4], [-3, -4], [1, 2]], [[-3, -4], [-1, -2], [-3, -4]], [[-3, -4], [-1, -2], [3, 4]], [[-3, -4], [1, 2], [-3, -4]], [[-3, -4], [1, 2], [3, 4]], [[-3, -4], [3, 4], [-1, -2]], [[-3, -4], [3, 4], [1, 2]], [[-2, -4], [-6, -12], [-2, -4]], [[-2, -4], [-6, -12], [2, 4]], [[-2, -4], [-6, -8], [-6, -8]], [[-2, -4], [-6, -8], [6, 8]], [[-2, -4], [-3, -5], [0, -1]], [[-2, -4], [-3, -5], [0, 1]], [[-2, -4], [-2, -4], [-6, -12]], [[-2, -4], [-2, -4], [6, 12]], [[-2, -4], [2, 4], [-6, -12]], [[-2, -4], [2, 4], [6, 12]], [[-2, -4], [3, 5], [0, -1]], [[-2, -4], [3, 5], [0, 1]], [[-2, -4], [6, 8], [-6, -8]], [[-2, -4], [6, 8], [6, 8]], [[-2, -4], [6, 12], [-2, -4]], [[-2, -4], [6, 12], [2, 4]], [[-2, -3], [-2, -2], [-3, -5]], [[-2, -3], [-2, -2], [3, 5]], [[-2, -3], [2, 2], [-3, -5]], [[-2, -3], [2, 2], [3, 5]], [[-2, -2], [-3, -5], [-2, -3]], [[-2, -2], [-3, -5], [2, 3]], [[-2, -2], [0, -2], [-8, -12]], [[-2, -2], [0, -2], [8, 12]], [[-2, -2], [0, 2], [-8, -12]], [[-2, -2], [0, 2], [8, 12]], [[-2, -2], [3, 5], [-2, -3]], [[-2, -2], [3, 5], [2, 3]], [[-1, -2], [-3, -6], [-1, -2]], [[-1, -2], [-3, -6], [1, 2]], [[-1, -2], [-3, -4], [-3, -4]], [[-1, -2], [-3, -4], [3, 4]], [[-1, -2], [-1, -2], [-3, -6]], [[-1, -2], [-1, -2], [3, 6]], [[-1, -2], [1, 2], [-3, -6]], [[-1, -2], [1, 2], [3, 6]], [[-1, -2], [3, 4], [-3, -4]], [[-1, -2], [3, 4], [3, 4]], [[-1, -2], [3, 6], [-1, -2]], [[-1, -2], [3, 6], [1, 2]], [[0, -2], [-8, -12], [-2, -2]], [[0, -2], [-8, -12], [2, 2]], [[0, -2], [-4, -8], [-6, -10]], [[0, -2], [-4, -8], [6, 10]], [[0, -2], [4, 8], [-6, -10]], [[0, -2], [4, 8], [6, 10]], [[0, -2], [8, 12], [-2, -2]], [[0, -2], [8, 12], [2, 2]], [[-1, -1], [0, -1], [-4, -6]], [[-1, -1], [0, -1], [4, 6]], [[-1, -1], [0, 1], [-4, -6]], [[-1, -1], [0, 1], [4, 6]], [[0, -1], [-4, -6], [-1, -1]], [[0, -1], [-4, -6], [1, 1]], [[0, -1], [-2, -4], [-3, -5]], [[0, -1], [-2, -4], [3, 5]], [[0, -1], [2, 4], [-3, -5]], [[0, -1], [2, 4], [3, 5]], [[0, -1], [4, 6], [-1, -1]], [[0, -1], [4, 6], [1, 1]], [[0, 1], [-4, -6], [-1, -1]], [[0, 1], [-4, -6], [1, 1]], [[0, 1], [-2, -4], [-3, -5]], [[0, 1], [-2, -4], [3, 5]], [[0, 1], [2, 4], [-3, -5]], [[0, 1], [2, 4], [3, 5]], [[0, 1], [4, 6], [-1, -1]], [[0, 1], [4, 6], [1, 1]], [[1, 1], [0, -1], [-4, -6]], [[1, 1], [0, -1], [4, 6]], [[1, 1], [0, 1], [-4, -6]], [[1, 1], [0, 1], [4, 6]], [[0, 2], [-8, -12], [-2, -2]], [[0, 2], [-8, -12], [2, 2]], [[0, 2], [-4, -8], [-6, -10]], [[0, 2], [-4, -8], [6, 10]], [[0, 2], [4, 8], [-6, -10]], [[0, 2], [4, 8], [6, 10]], [[0, 2], [8, 12], [-2, -2]], [[0, 2], [8, 12], [2, 2]], [[1, 2], [-3, -6], [-1, -2]], [[1, 2], [-3, -6], [1, 2]], [[1, 2], [-3, -4], [-3, -4]], [[1, 2], [-3, -4], [3, 4]], [[1, 2], [-1, -2], [-3, -6]], [[1, 2], [-1, -2], [3, 6]], [[1, 2], [1, 2], [-3, -6]], [[1, 2], [1, 2], [3, 6]], [[1, 2], [3, 4], [-3, -4]], [[1, 2], [3, 4], [3, 4]], [[1, 2], [3, 6], [-1, -2]], [[1, 2], [3, 6], [1, 2]], [[2, 2], [-3, -5], [-2, -3]], [[2, 2], [-3, -5], [2, 3]], [[2, 2], [0, -2], [-8, -12]], [[2, 2], [0, -2], [8, 12]], [[2, 2], [0, 2], [-8, -12]], [[2, 2], [0, 2], [8, 12]], [[2, 2], [3, 5], [-2, -3]], [[2, 2], [3, 5], [2, 3]], [[2, 3], [-2, -2], [-3, -5]], [[2, 3], [-2, -2], [3, 5]], [[2, 3], [2, 2], [-3, -5]], [[2, 3], [2, 2], [3, 5]], [[2, 4], [-6, -12], [-2, -4]], [[2, 4], [-6, -12], [2, 4]], [[2, 4], [-6, -8], [-6, -8]], [[2, 4], [-6, -8], [6, 8]], [[2, 4], [-3, -5], [0, -1]], [[2, 4], [-3, -5], [0, 1]], [[2, 4], [-2, -4], [-6, -12]], [[2, 4], [-2, -4], [6, 12]], [[2, 4], [2, 4], [-6, -12]], [[2, 4], [2, 4], [6, 12]], [[2, 4], [3, 5], [0, -1]], [[2, 4], [3, 5], [0, 1]], [[2, 4], [6, 8], [-6, -8]], [[2, 4], [6, 8], [6, 8]], [[2, 4], [6, 12], [-2, -4]], [[2, 4], [6, 12], [2, 4]], [[3, 4], [-3, -4], [-1, -2]], [[3, 4], [-3, -4], [1, 2]], [[3, 4], [-1, -2], [-3, -4]], [[3, 4], [-1, -2], [3, 4]], [[3, 4], [1, 2], [-3, -4]], [[3, 4], [1, 2], [3, 4]], [[3, 4], [3, 4], [-1, -2]], [[3, 4], [3, 4], [1, 2]], [[4, 4], [-6, -10], [-4, -6]], [[4, 4], [-6, -10], [4, 6]], [[4, 4], [6, 10], [-4, -6]], [[4, 4], [6, 10], [4, 6]], [[3, 5], [-2, -3], [-2, -2]], [[3, 5], [-2, -3], [2, 2]], [[3, 5], [0, -1], [-2, -4]], [[3, 5], [0, -1], [2, 4]], [[3, 5], [0, 1], [-2, -4]], [[3, 5], [0, 1], [2, 4]], [[3, 5], [2, 3], [-2, -2]], [[3, 5], [2, 3], [2, 2]], [[3, 6], [-1, -2], [-1, -2]], [[3, 6], [-1, -2], [1, 2]], [[3, 6], [1, 2], [-1, -2]], [[3, 6], [1, 2], [1, 2]], [[4, 6], [-4, -4], [-6, -10]], [[4, 6], [-4, -4], [6, 10]], [[4, 6], [-1, -1], [0, -1]], [[4, 6], [-1, -1], [0, 1]], [[4, 6], [1, 1], [0, -1]], [[4, 6], [1, 1], [0, 1]], [[4, 6], [4, 4], [-6, -10]], [[4, 6], [4, 4], [6, 10]], [[4, 8], [-6, -10], [0, -2]], [[4, 8], [-6, -10], [0, 2]], [[4, 8], [6, 10], [0, -2]], [[4, 8], [6, 10], [0, 2]], [[6, 8], [-6, -8], [-2, -4]], [[6, 8], [-6, -8], [2, 4]], [[6, 8], [-2, -4], [-6, -8]], [[6, 8], [-2, -4], [6, 8]], [[6, 8], [2, 4], [-6, -8]], [[6, 8], [2, 4], [6, 8]], [[6, 8], [6, 8], [-2, -4]], [[6, 8], [6, 8], [2, 4]], [[6, 10], [-4, -6], [-4, -4]], [[6, 10], [-4, -6], [4, 4]], [[6, 10], [0, -2], [-4, -8]], [[6, 10], [0, -2], [4, 8]], [[6, 10], [0, 2], [-4, -8]], [[6, 10], [0, 2], [4, 8]], [[6, 10], [4, 6], [-4, -4]], [[6, 10], [4, 6], [4, 4]], [[6, 12], [-2, -4], [-2, -4]], [[6, 12], [-2, -4], [2, 4]], [[6, 12], [2, 4], [-2, -4]], [[6, 12], [2, 4], [2, 4]], [[8, 12], [-2, -2], [0, -2]], [[8, 12], [-2, -2], [0, 2]], [[8, 12], [2, 2], [0, -2]], [[8, 12], [2, 2], [0, 2]]],
      "balls": [13, 218, 115, 112, 177, 80, 38, 208, 11, 56, 21, 198, 186, 205, 58, 46, 29, 230, 132, 64, 124, 148, 137, 96, 223, 75, 136, 174, 152, 121, 25, 183, 128, 130, 5, 184, 168, 107, 49, 9, 26, 87, 157, 140, 216, 1, 14, 28, 190, 119, 204, 50, 166, 2, 105, 170, 40, 52, 161, 30, 77, 90, 154, 217, 89, 236, 37, 213, 100, 55, 110, 214, 194, 167, 85, 193, 181, 159, 104, 123, 143, 36, 7, 67, 155, 79, 61, 24, 195, 23, 207, 227, 138, 127, 44, 34, 18, 73, 94, 47, 59, 202, 97, 84, 22, 133, 74, 191, 71, 0, 233, 129, 33, 101, 120, 151, 48, 185, 35, 106, 4, 81, 111, 145, 122, 158, 173, 232, 187, 199, 98, 172, 231, 149, 222, 27, 144, 103, 76, 200, 176, 45, 182, 72, 114, 113, 51, 95, 10, 3, 43, 8, 31, 162, 6, 164, 150, 125, 239, 226, 126, 92, 206, 219, 16, 19, 65, 169, 203, 228, 220, 39, 66, 180, 192, 20, 117, 62, 142, 70, 146, 210, 78, 108, 156, 139, 234, 118, 178, 109, 189, 175, 60, 116, 135, 88, 197, 171, 83, 91, 54, 147, 163, 179, 212, 235, 225, 165, 141, 201, 68, 17, 15, 82, 221, 32, 229, 134, 215, 160, 42, 63, 224, 53, 41, 209, 12, 238, 153, 99, 102, 211, 237, 69, 188, 131, 86, 57, 196, 93],
      "struts": [{
        "start": 90,
        "end": 62,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 22
      }, {
        "start": 136,
        "end": 124,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 40
      }, {
        "start": 19,
        "end": 55,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 23
      }, {
        "start": 164,
        "end": 140,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 4
      }, {
        "start": 109,
        "end": 83,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 32
      }, {
        "start": 78,
        "end": 34,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 59
      }, {
        "start": 110,
        "end": 84,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 47
      }, {
        "start": 46,
        "end": 14,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 57
      }, {
        "start": 86,
        "end": 50,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 58
      }, {
        "start": 8,
        "end": 40,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 12
      }, {
        "start": 159,
        "end": 191,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 13
      }, {
        "start": 201,
        "end": 233,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 18
      }, {
        "start": 88,
        "end": 60,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 19
      }, {
        "start": 135,
        "end": 123,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 55
      }, {
        "start": 209,
        "end": 239,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 0
      }, {
        "start": 52,
        "end": 16,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 36
      }, {
        "start": 13,
        "end": 45,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 26
      }, {
        "start": 230,
        "end": 198,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 42
      }, {
        "start": 6,
        "end": 38,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 18
      }, {
        "start": 63,
        "end": 91,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 52
      }, {
        "start": 57,
        "end": 21,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 38
      }, {
        "start": 218,
        "end": 182,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 38
      }, {
        "start": 177,
        "end": 149,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 22
      }, {
        "start": 44,
        "end": 12,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 56
      }, {
        "start": 107,
        "end": 119,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 16
      }, {
        "start": 210,
        "end": 162,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 44
      }, {
        "start": 118,
        "end": 106,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 46
      }, {
        "start": 122,
        "end": 134,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 25
      }, {
        "start": 32,
        "end": 2,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 45
      }, {
        "start": 97,
        "end": 73,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 7
      }, {
        "start": 227,
        "end": 195,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 56
      }, {
        "start": 131,
        "end": 157,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 2
      }, {
        "start": 214,
        "end": 174,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 39
      }, {
        "start": 189,
        "end": 153,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 58
      }, {
        "start": 95,
        "end": 69,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 35
      }, {
        "start": 54,
        "end": 18,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 53
      }, {
        "start": 125,
        "end": 137,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 10
      }, {
        "start": 17,
        "end": 53,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 6
      }, {
        "start": 100,
        "end": 112,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 1
      }, {
        "start": 186,
        "end": 222,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 6
      }, {
        "start": 74,
        "end": 98,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 34
      }, {
        "start": 41,
        "end": 9,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 42
      }, {
        "start": 235,
        "end": 203,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 33
      }, {
        "start": 168,
        "end": 212,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 24
      }, {
        "start": 115,
        "end": 103,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 40
      }, {
        "start": 228,
        "end": 196,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 41
      }, {
        "start": 197,
        "end": 229,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 11
      }, {
        "start": 81,
        "end": 49,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 43
      }, {
        "start": 163,
        "end": 211,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 14
      }, {
        "start": 238,
        "end": 208,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 30
      }, {
        "start": 141,
        "end": 165,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 34
      }, {
        "start": 175,
        "end": 215,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 9
      }, {
        "start": 199,
        "end": 231,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 12
      }, {
        "start": 24,
        "end": 64,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 9
      }, {
        "start": 128,
        "end": 154,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 17
      }, {
        "start": 152,
        "end": 188,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 28
      }, {
        "start": 143,
        "end": 167,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 37
      }, {
        "start": 146,
        "end": 172,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 20
      }, {
        "start": 72,
        "end": 96,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 37
      }, {
        "start": 35,
        "end": 79,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 29
      }, {
        "start": 173,
        "end": 147,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 50
      }, {
        "start": 133,
        "end": 121,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 46
      }, {
        "start": 138,
        "end": 126,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 31
      }, {
        "start": 67,
        "end": 93,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 20
      }, {
        "start": 3,
        "end": 33,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 15
      }, {
        "start": 237,
        "end": 207,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 45
      }, {
        "start": 216,
        "end": 180,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 51
      }, {
        "start": 120,
        "end": 132,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 16
      }, {
        "start": 221,
        "end": 185,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 53
      }, {
        "start": 184,
        "end": 220,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 23
      }, {
        "start": 22,
        "end": 58,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 21
      }, {
        "start": 5,
        "end": 37,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 3
      }, {
        "start": 48,
        "end": 80,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 13
      }, {
        "start": 181,
        "end": 217,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 21
      }, {
        "start": 206,
        "end": 236,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 15
      }, {
        "start": 156,
        "end": 130,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 32
      }, {
        "start": 65,
        "end": 25,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 39
      }, {
        "start": 85,
        "end": 111,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 17
      }, {
        "start": 43,
        "end": 11,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 41
      }, {
        "start": 105,
        "end": 117,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 25
      }, {
        "start": 145,
        "end": 171,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 5
      }, {
        "start": 113,
        "end": 101,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 31
      }, {
        "start": 116,
        "end": 104,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 55
      }, {
        "start": 68,
        "end": 94,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 5
      }, {
        "start": 39,
        "end": 7,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 48
      }, {
        "start": 70,
        "end": 26,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 54
      }, {
        "start": 59,
        "end": 23,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 51
      }, {
        "start": 190,
        "end": 158,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 43
      }, {
        "start": 51,
        "end": 87,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 28
      }, {
        "start": 102,
        "end": 114,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 10
      }, {
        "start": 232,
        "end": 200,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 48
      }, {
        "start": 148,
        "end": 176,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 52
      }, {
        "start": 170,
        "end": 144,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 35
      }, {
        "start": 194,
        "end": 226,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 26
      }, {
        "start": 192,
        "end": 224,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 27
      }, {
        "start": 127,
        "end": 139,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 1
      }, {
        "start": 150,
        "end": 178,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 49
      }, {
        "start": 0,
        "end": 30,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 0
      }, {
        "start": 179,
        "end": 151,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 19
      }, {
        "start": 61,
        "end": 89,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 49
      }, {
        "start": 205,
        "end": 161,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 59
      }, {
        "start": 28,
        "end": 76,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 14
      }, {
        "start": 225,
        "end": 193,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 57
      }, {
        "start": 183,
        "end": 219,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 8
      }, {
        "start": 36,
        "end": 4,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 33
      }, {
        "start": 99,
        "end": 75,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 4
      }, {
        "start": 223,
        "end": 187,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 36
      }, {
        "start": 10,
        "end": 42,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 11
      }, {
        "start": 15,
        "end": 47,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 27
      }, {
        "start": 77,
        "end": 29,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 44
      }, {
        "start": 166,
        "end": 142,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 7
      }, {
        "start": 213,
        "end": 169,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 54
      }, {
        "start": 155,
        "end": 129,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 47
      }, {
        "start": 92,
        "end": 66,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 50
      }, {
        "start": 27,
        "end": 71,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 24
      }, {
        "start": 160,
        "end": 204,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 29
      }, {
        "start": 82,
        "end": 108,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 2
      }, {
        "start": 202,
        "end": 234,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 3
      }, {
        "start": 31,
        "end": 1,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 30
      }, {
        "start": 20,
        "end": 56,
        "length": [2, 3],
        "orbit": "turquoise",
        "orientation": 8
      }]
    });
  });
  main.variable(observer("red_quat_120_cell")).define("red_quat_120_cell", ["convertVsonModel"], function (convertVsonModel) {
    return fetch("https://gist.githubusercontent.com/vorth/a6d27d0e00499653c1572cc41aaa3aa5/raw/f977b625ade4f87c06093bfa5de1acde7ef90000/red-quaternion-120-cell.vson").then(function (response) {
      return response.json();
    }).then(convertVsonModel);
  });
  main.variable(observer("hyperdo_cells")).define("hyperdo_cells", ["convertVsonModel"], function (convertVsonModel) {
    return convertVsonModel({
      "field": "golden",
      "symmetry": "icosahedral",
      "vertices": [[[-5, -8], [0, 0], [-2, -3]], [[-5, -8], [0, 0], [2, 3]], [[-3, -5], [-3, -5], [-3, -5]], [[-3, -5], [-3, -5], [3, 5]], [[-3, -5], [3, 5], [-3, -5]], [[-3, -5], [3, 5], [3, 5]], [[-2, -3], [-5, -8], [0, 0]], [[-2, -3], [5, 8], [0, 0]], [[0, 0], [-3, -5], [8, 13]], [[0, 0], [-2, -3], [-5, -8]], [[0, 0], [-2, -3], [5, 8]], [[0, 0], [0, 0], [0, 0]], [[0, 0], [0, 0], [10, 16]], [[0, 0], [2, 3], [-5, -8]], [[0, 0], [2, 3], [5, 8]], [[0, 0], [3, 5], [8, 13]], [[2, 3], [-5, -8], [0, 0]], [[2, 3], [5, 8], [0, 0]], [[3, 5], [-5, -8], [8, 13]], [[3, 5], [-3, -5], [-3, -5]], [[3, 5], [-3, -5], [3, 5]], [[3, 5], [0, 0], [11, 18]], [[3, 5], [3, 5], [-3, -5]], [[3, 5], [3, 5], [3, 5]], [[3, 5], [5, 8], [8, 13]], [[5, 8], [-5, -8], [5, 8]], [[5, 8], [-3, -5], [10, 16]], [[5, 8], [0, 0], [-2, -3]], [[5, 8], [0, 0], [2, 3]], [[5, 8], [3, 5], [10, 16]], [[5, 8], [5, 8], [5, 8]], [[8, 13], [-3, -5], [5, 8]], [[8, 13], [-2, -3], [8, 13]], [[8, 13], [0, 0], [3, 5]], [[8, 13], [2, 3], [8, 13]], [[8, 13], [3, 5], [5, 8]]],
      "balls": [2, 15, 6, 20, 26, 12, 8, 4, 10, 27, 23, 11, 25, 18, 16, 34, 19, 31, 5, 30, 35, 22, 29, 9, 33, 7, 32, 1, 28, 14, 21, 17, 13, 0, 3, 24],
      "struts": [{
        "start": 4,
        "end": 7,
        "length": [4, 6],
        "orbit": "blue",
        "orientation": 10
      }, {
        "start": 23,
        "end": 17,
        "length": [4, 6],
        "orbit": "blue",
        "orientation": 55
      }, {
        "start": 4,
        "end": 0,
        "length": [4, 6],
        "orbit": "blue",
        "orientation": 39
      }, {
        "start": 5,
        "end": 7,
        "length": [4, 6],
        "orbit": "blue",
        "orientation": 52
      }, {
        "start": 27,
        "end": 28,
        "length": [4, 6],
        "orbit": "blue",
        "orientation": 2
      }, {
        "start": 26,
        "end": 21,
        "length": [4, 6],
        "orbit": "blue",
        "orientation": 51
      }, {
        "start": 19,
        "end": 9,
        "length": [4, 6],
        "orbit": "blue",
        "orientation": 56
      }, {
        "start": 12,
        "end": 21,
        "length": [1, 2],
        "orbit": "yellow",
        "orientation": 8
      }, {
        "start": 30,
        "end": 23,
        "length": [1, 2],
        "orbit": "yellow",
        "orientation": 19
      }, {
        "start": 2,
        "end": 0,
        "length": [4, 6],
        "orbit": "blue",
        "orientation": 51
      }, {
        "start": 13,
        "end": 9,
        "length": [4, 6],
        "orbit": "blue",
        "orientation": 16
      }, {
        "start": 19,
        "end": 16,
        "length": [4, 6],
        "orbit": "blue",
        "orientation": 40
      }, {
        "start": 2,
        "end": 9,
        "length": [4, 6],
        "orbit": "blue",
        "orientation": 23
      }, {
        "start": 10,
        "end": 14,
        "length": [4, 6],
        "orbit": "blue",
        "orientation": 1
      }, {
        "start": 3,
        "end": 1,
        "length": [4, 6],
        "orbit": "blue",
        "orientation": 54
      }, {
        "start": 8,
        "end": 18,
        "length": [2, 3],
        "orbit": "red",
        "orientation": 15
      }, {
        "start": 3,
        "end": 6,
        "length": [4, 6],
        "orbit": "blue",
        "orientation": 25
      }, {
        "start": 15,
        "end": 14,
        "length": [1, 2],
        "orbit": "yellow",
        "orientation": 22
      }, {
        "start": 23,
        "end": 28,
        "length": [4, 6],
        "orbit": "blue",
        "orientation": 24
      }, {
        "start": 24,
        "end": 15,
        "length": [2, 3],
        "orbit": "red",
        "orientation": 30
      }, {
        "start": 22,
        "end": 13,
        "length": [4, 6],
        "orbit": "blue",
        "orientation": 53
      }, {
        "start": 30,
        "end": 35,
        "length": [2, 3],
        "orbit": "red",
        "orientation": 15
      }, {
        "start": 32,
        "end": 26,
        "length": [4, 6],
        "orbit": "blue",
        "orientation": 41
      }, {
        "start": 25,
        "end": 31,
        "length": [2, 3],
        "orbit": "red",
        "orientation": 0
      }, {
        "start": 1,
        "end": 0,
        "length": [4, 6],
        "orbit": "blue",
        "orientation": 47
      }, {
        "start": 16,
        "end": 6,
        "length": [4, 6],
        "orbit": "blue",
        "orientation": 45
      }, {
        "start": 20,
        "end": 16,
        "length": [4, 6],
        "orbit": "blue",
        "orientation": 22
      }, {
        "start": 30,
        "end": 24,
        "length": [2, 3],
        "orbit": "red",
        "orientation": 32
      }, {
        "start": 32,
        "end": 31,
        "length": [1, 2],
        "orbit": "yellow",
        "orientation": 22
      }, {
        "start": 3,
        "end": 10,
        "length": [4, 6],
        "orbit": "blue",
        "orientation": 11
      }, {
        "start": 33,
        "end": 35,
        "length": [2, 3],
        "orbit": "red",
        "orientation": 1
      }, {
        "start": 5,
        "end": 1,
        "length": [4, 6],
        "orbit": "blue",
        "orientation": 36
      }, {
        "start": 31,
        "end": 33,
        "length": [2, 3],
        "orbit": "red",
        "orientation": 46
      }, {
        "start": 25,
        "end": 18,
        "length": [2, 3],
        "orbit": "red",
        "orientation": 32
      }, {
        "start": 23,
        "end": 14,
        "length": [4, 6],
        "orbit": "blue",
        "orientation": 41
      }, {
        "start": 10,
        "end": 8,
        "length": [1, 2],
        "orbit": "yellow",
        "orientation": 2
      }, {
        "start": 22,
        "end": 17,
        "length": [4, 6],
        "orbit": "blue",
        "orientation": 7
      }, {
        "start": 25,
        "end": 20,
        "length": [1, 2],
        "orbit": "yellow",
        "orientation": 54
      }, {
        "start": 34,
        "end": 29,
        "length": [4, 6],
        "orbit": "blue",
        "orientation": 38
      }, {
        "start": 5,
        "end": 14,
        "length": [4, 6],
        "orbit": "blue",
        "orientation": 8
      }, {
        "start": 2,
        "end": 6,
        "length": [4, 6],
        "orbit": "blue",
        "orientation": 37
      }, {
        "start": 12,
        "end": 8,
        "length": [2, 3],
        "orbit": "red",
        "orientation": 16
      }, {
        "start": 34,
        "end": 35,
        "length": [1, 2],
        "orbit": "yellow",
        "orientation": 17
      }, {
        "start": 20,
        "end": 28,
        "length": [4, 6],
        "orbit": "blue",
        "orientation": 6
      }, {
        "start": 22,
        "end": 27,
        "length": [4, 6],
        "orbit": "blue",
        "orientation": 21
      }, {
        "start": 29,
        "end": 24,
        "length": [1, 2],
        "orbit": "yellow",
        "orientation": 54
      }, {
        "start": 7,
        "end": 17,
        "length": [4, 6],
        "orbit": "blue",
        "orientation": 0
      }, {
        "start": 26,
        "end": 18,
        "length": [1, 2],
        "orbit": "yellow",
        "orientation": 19
      }, {
        "start": 29,
        "end": 21,
        "length": [4, 6],
        "orbit": "blue",
        "orientation": 39
      }, {
        "start": 4,
        "end": 13,
        "length": [4, 6],
        "orbit": "blue",
        "orientation": 26
      }, {
        "start": 20,
        "end": 10,
        "length": [4, 6],
        "orbit": "blue",
        "orientation": 38
      }, {
        "start": 12,
        "end": 15,
        "length": [2, 3],
        "orbit": "red",
        "orientation": 46
      }, {
        "start": 32,
        "end": 34,
        "length": [4, 6],
        "orbit": "blue",
        "orientation": 1
      }, {
        "start": 28,
        "end": 33,
        "length": [1, 2],
        "orbit": "yellow",
        "orientation": 8
      }, {
        "start": 19,
        "end": 27,
        "length": [4, 6],
        "orbit": "blue",
        "orientation": 9
      }]
    });
  });
  main.variable(observer("convertVsonModel")).define("convertVsonModel", ["parseVsonVector", "resolveSegments"], function (parseVsonVector, resolveSegments) {
    return function convertVsonModel(vson) {
      var vertices = vson.vertices.map(parseVsonVector);

      function flattenStrut(strut) {
        return [vertices[strut.start], vertices[strut.end]];
      }

      var model = resolveSegments(vson.struts.map(flattenStrut));
      var inputPanels = vson.panels || [];
      model.panels = inputPanels && inputPanels.map(function (panel) {
        var panelVerts = panel.vertices.map(function (vertex) {
          return model.vertices.add(vertices[vertex]);
        });
        return {
          vertices: panelVerts,
          color: panel.color || "#99aa00"
        };
      });
      return model;
    };
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject2());
  });
  main.variable(observer("byr2vZome")).define("byr2vZome", function () {
    return function byr2vZome(byr) {
      var _byr = _slicedToArray(byr, 3),
          blue = _byr[0],
          yellow = _byr[1],
          red = _byr[2];

      return 3 * blue % 4 * 15 + yellow + red * 3;
    };
  });
  main.variable(observer("byr2index")).define("byr2index", function () {
    return function byr2index(byr) {
      var _byr2 = _slicedToArray(byr, 3),
          blue = _byr2[0],
          yellow = _byr2[1],
          red = _byr2[2];

      return blue * 15 + yellow * 5 + red;
    };
  });
  main.variable(observer("vZome2byr")).define("vZome2byr", function () {
    return function vZome2byr(vZomeIndex) {
      var blue = Math.floor(vZomeIndex / 15) * 3 % 4;
      var yellow = vZomeIndex % 3;
      var red = Math.floor((vZomeIndex - yellow - 3 * blue % 4 * 15) / 3);
      return [blue, yellow, red];
    };
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject3());
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject4());
  });
  var child1 = runtime.module(define1);
  main.import("resolveSegments", child1);
  main.import("vZomeRenderer", child1);
  var child2 = runtime.module(define2);
  main.import("parseVsonVector", child2);
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject5());
  });
  return main;
}